import { trackingView } from './trackingView'

export const statApi = {
  trackingView
}